import { Button } from "components"
import { TableCell, TableRow } from "components/atoms/BasicTable"
import { SimpleBadge } from "components/atoms/SimpleBadge"
import { ICompanyPage } from "types/company/company.type"

export const Row = (props: ICompanyPage & { handleEditModal: (id: string) => void, handleDeleteModal: (id: string) => void }) => {
    const { clientPage, handleEditModal, handleDeleteModal } = props
    return (
        <TableRow key={clientPage.id}>
            <TableCell>
                <div className="badge primary font-bold qualigence:font-mono min-w-[35px] sm off">{clientPage?.pageUrl}</div>
            </TableCell>
            <TableCell className="text-center">
                <div className="flex w-full justify-center">
                    {clientPage?.pageIntent && <SimpleBadge type={clientPage.pageIntent as any} />}
                </div>
            </TableCell>
            <TableCell >
                <div className="flex ml-auto gap-4">
                    <div className="ml-auto flex gap-4">
                        <Button size="xs" iconName="edit" iconSize={16} className={`!border !border-solid !font-bold !text-[14px]  !bg-gray-800  text-white-500 !border-gray-700 hover:!bg-primary-600 hover:!text-primary-500 hover:!border-primary-500`} onClick={() => handleEditModal(clientPage.id)}>Edit</Button>
                        <Button size="xs" iconName="trash" iconSize={16} className={`!border !border-solid !font-bold !text-[14px] !bg-gray-800  text-white-500 !border-gray-700 hover:!bg-primary-600 hover:!text-primary-500 hover:!border-primary-500`} onClick={() => handleDeleteModal(clientPage.id)}>Remove</Button>
                    </div>
                </div>
            </TableCell>
        </TableRow>
    )
}